import React, { useMemo } from 'react';
import NumArrow from '@sg/components/NumArrow';
import {indicatorValRankingFormat} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overview/PerformanceSummary/cardUtils';
import {mathFormat} from '@sg/utils/common';
import './index.scss';  
// warningColor
const DataProcessing = (props: any) => {
  const {data, rate, content, isChangeContentPosition, dataSize, valueFormatter} = props;
  const getNumConfig = (rateValue: any, index: number) => {
    let rateStr: string | undefined;
    if (typeof rateValue === 'number') {
      if (Number.isFinite(rateValue)) {
        rateStr = rateValue.toFixed(2);
      } else {
        rateStr = undefined;
      }
    } else if (typeof rateValue === 'string') {
      const trimmed = rateValue.trim();
      if (
        !trimmed ||
        trimmed === '-' ||
        trimmed === '--' ||
        trimmed === '-%' ||
        trimmed.toLowerCase() === 'nan'
      ) {
        rateStr = undefined;
      } else {
        const withoutPercent = trimmed.endsWith('%') ? trimmed.slice(0, -1) : trimmed;
        const numericRate = Number(withoutPercent);
        if (Number.isFinite(numericRate)) {
          rateStr = numericRate.toFixed(2);
        }
      }
    }

    if (!rateStr) {
      return undefined;
    }

    const rateArr = rateStr.split(',');
    const targetRateRaw = rateArr[index];
    if (!targetRateRaw || Number(targetRateRaw) === 0) {
      return undefined;
    }
    const targetRate = `${targetRateRaw}%`;
    if (targetRate) {
      const {
        _indicatorContent,
        _indicatorSize,
        _indicatorColor,
        _isIndicatorArrow,
        _indicatprsArrowColor,
      } = indicatorValRankingFormat(targetRate);
      return {
        numContent: _indicatorContent,
        numColor: _indicatorColor,
        numSize: _indicatorSize,
        arrow:  _isIndicatorArrow,
        arrowColor: _indicatprsArrowColor,
        isShowZero: true,
      };
    }
  };

  const rateList = useMemo(() => {
    const [, rateText] = content || [];
    if (rateText) {
      return rateText.split(',') || [];
    }
    return [];
  }, [content]);
  
  return <div className="dbs-context-num-flex">
    {(data !== null && data !== undefined) ? (
      <>
        <span className="num-text" style={{fontSize: dataSize}}>
          {content?.[0]}
          {valueFormatter ? valueFormatter(data) : mathFormat(data)}
        </span>
        <div className='num-text-rank-wrap'>
          {
            <>
              {rateList?.map((rateText: string, index: number) => {
                const numArrowData = getNumConfig(rate, index);
                // Don't render if the value is 0 or empty
                if (!numArrowData || numArrowData.numSize === 'zero' || !rateText || rateText === '0' || rateText === '0%') {
                  return null;
                }
                return (
                  <div key={rateText} className="num-text-rank-item">
                    {!isChangeContentPosition && <span className="num-text-rank-text">
                      {rateText}
                    </span>}
                    <NumArrow dataContent={numArrowData} type={'num'}>
                      {' '}
                    </NumArrow>
                    {isChangeContentPosition && <span className="num-text-rank-text">
                      {rateText}
                    </span>}
                  </div>
                );
              })}
            </>
          }
        </div>
      </>
    ) : (
      <span className="num-text" style={{fontSize: dataSize}}>{data === 0 ? '0' : '-'}</span>
    )}
  </div>;
};

export default DataProcessing;